'use client'

import { type FC, useEffect } from 'react'

import { useGlobalConfigContext } from '../../global-config/context/globalConfigContext'
import { TENANT } from '../../tenant/tenantTypes'
import { useExperimentsContext } from '../components/ExperimentsContext'
import { EXPERIMENT_NAME_FAQ_PAGE } from '../model/EXPERIMENT_NAME'

export const FaqPageExperimentActivation: FC = () => {
  const { addExperimentKeysForActivation } = useExperimentsContext()
  const { tenant } = useGlobalConfigContext()

  useEffect(() => {
    if (tenant === TENANT.COM) {
      addExperimentKeysForActivation(EXPERIMENT_NAME_FAQ_PAGE)
    }
  }, [addExperimentKeysForActivation, tenant])

  return null
}
